query DateCalcNonConsecutiveDayTotals($dates: [Date]!, $rate: BigFloat!) {
  dateCalcNonConsecutiveDayTotals(rate: $rate, dates: $dates) {
    dayRate
    dayTotal
    endDate
    extendedTotal
    fullPeriods
    partialPeriodDays
    periodNo
    periodRate
    periodTotal
    startDate
  }
}
